import { TRIAL_DAYS } from "./workflowPlans";

/**
 * What the buy button on a Workflow Product shows, by who is looking. One place so the product page, the Workflow Products card and the
 * /pricing card always agree.
 *  - signed out: Start 7-day trial (sign in with Google, then straight to Stripe Checkout)
 *  - signed in, no subscription: Start 7-day trial (straight to Stripe Checkout); "Subscribe" once the trial has been used
 *  - signed in, paying subscriber: Manage subscription
 *  - signed in, open without paying (owner or tester code, organization seat): Open
 */
export type WorkflowCtaKind = "trial" | "subscribe" | "manage" | "open";

export interface WorkflowCtaInput { signedIn: boolean; entitled?: boolean; hasSubscription?: boolean; trialEligible?: boolean }

export function workflowCtaKind(s: WorkflowCtaInput): WorkflowCtaKind {
  if (!s.signedIn) return "trial";
  if (s.entitled) return s.hasSubscription ? "manage" : "open";
  if (s.trialEligible === false) return "subscribe";
  return "trial";
}

export function workflowCtaLabel(kind: WorkflowCtaKind, monthlyUsd: string): string {
  switch (kind) {
    case "trial": return `Start ${TRIAL_DAYS}-day trial · $${monthlyUsd}/mo`;
    case "subscribe": return `Subscribe · $${monthlyUsd}/mo`;
    case "manage": return "Manage subscription";
    case "open": return "Open";
  }
}
